// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import TabNavigation from '../../../shared/components/tab-navigation';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {getNavigationTabs} from '../../shared/services/claim-navigation-helper';

const AllClaimsHeader = (props, context) => {

    const countObject = {
        allClaims: props.allClaimsCount,
        claimSearch: props.claimSearchCount,
        dealerInvoices: props.dealerInvoiceCount
    };

    return (
        <header className='claim-search-header'>
            <TabNavigation tabs={getNavigationTabs(countObject, props.hasSearchResults, context.user.privacy.showWaitingForDealerInvoice)}/>
        </header>
    );

};

AllClaimsHeader.displayName = 'AllClaimsHeader';
AllClaimsHeader.propTypes = {
    allClaimsCount: PropTypes.number.isRequired,
    claimSearchCount: PropTypes.number.isRequired,
    dealerInvoiceCount: PropTypes.number.isRequired,
    hasSearchResults: PropTypes.bool.isRequired
};
AllClaimsHeader.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default AllClaimsHeader;



// WEBPACK FOOTER //
// ./src/claim/all-claims/components/all-claims-header.js